import React, { useState, useEffect, useRef } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import { useNavigate } from "react-router-dom";
// import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Select from "react-select";
import {
  getSupplierById,
  getSuppliersList,
} from "../../../service/Suppliers/SuppliersService";
import { Formik, Form, Field } from "formik";
import { searchUnspc } from "../../../service/Segment/SegmentService";
import { getUnspcAdd } from "../../../service/Product/ProductService";
import { toast } from "react-toastify";
import {
  getAllProductDetailslist,
  addUnspscData,
} from "../../../service/Product/ProductService";
import { Country } from "country-state-city";
import {
  addProduct,
  getSelectedUnspscDetails,
} from "../../../service/Segment/SegmentService";
import webApi from "../../../WebApi/WebApi";
import instance from "../../../WebApi/WebApi";
import { useLocation } from "react-router-dom";
import { getCountry } from "react-international-phone";
import { Button, FormLabel, FormCheck, FormControl } from "react-bootstrap";
import { getAllVatlist } from "../../../service/VAT/VatService";
import useUnitData from "./UnitData";
import { useTranslation } from "react-i18next";
import debounce from "lodash/debounce";
import "./AddProduct.css";

const Addproduct = () => {
  //Search
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [totalSearchResult, setTotalSearchResult] = useState(0);
  const [search, setSearch] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchResultsEnd, setSearchResultsEnd] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [selectedSearchResult, setSelectedSearchResult] = useState("");
  const resultsRef = useRef(null); // Reference for search results div

  const { t } = useTranslation();
  const unitData = useUnitData();
  const location = useLocation();
  const navigate = useNavigate();
  const SupplerId = new URLSearchParams(location.search).get("id");
  const [allSupplierDataList, setAllSupplierDataList] = useState([]);
  const [searchOptions, setSearchOptions] = useState([]);
  const [selected, setSelected] = useState([]);
  const [showUnspc, setShowUnspc] = useState(false);
  const [segmentCode, setSegmentCode] = useState("");
  const [supplier, setSupplier] = useState([]);
  const [vat, setVat] = useState("");
  const [month, setMonth] = useState("");
  const [finalStartDate, setFinalStartDate] = useState("");
  const [finalEndDate, setFinalEndDate] = useState("");
  const [UNSPSCCode, setUNSPSCCode] = useState("");
  const [getProductId, setProductId] = useState([]);
  const [supplierDetails, setSupperDetails] = useState([]);
  const [allVatList, setAllVatList] = useState([]);
  const [vatList, setVatList] = useState([]);

  const [isToggleddata, setToggleddata] = useState(true);
  const [adminSupplierData, setAdminSupplierData] = useState({});
  let countryData = Country.getAllCountries();

  //list of suppliers
  async function getInvoiceSupplierDataList() {
    getSuppliersList().then(function (result) {
      const response = result?.data;
      // //  console.log(response?.data?.listSupplier.map(item=>{return({id:item.id,name:item.name})}),"response")
      //   setAllSupplierDataList(response?.data?.listSupplier);
      setAllSupplierDataList(
        response?.data?.listSupplier.map((item) => {
          return { id: item.id, name: item.name };
        })
      );
    });
  }
  function titleCase(str) {
    str = str?.toLowerCase()?.split(" ");
    for (var i = 0; i < str?.length; i++) {
      str[i] = str[i]?.charAt(0)?.toUpperCase() + str[i]?.slice(1);
    }
    return str?.join(" ");
  }

  useEffect(() => {
    getInvoiceSupplierDataList();
    getSupplierDetailsById();
  }, []);
  const getSupplierDetailsById = async () => {
    const response = await getSupplierById(SupplerId);
    setSupperDetails(response?.data?.data?.supplierDetails);
    getVatData(response?.data?.data?.supplierDetails?.country);
  };
  const getVatData = async (code) => {
    const data = {
      countryCode: code,
    };
    try {
      const response = await instance.post(
        "/customer/vat/get-vat-by-country",
        data
      );
      setVatList(response?.data?.data?.Vat[0]?.vat || []);
    //  console.log("response--2", response);
    } catch (err) {
    //  console.log(err);
    }
  };

  const afterUpdateUnspschandledata = () => {
    // setToggleddata(!isToggleddata);
    getAllProductDetailslist(
      supplier,
      vat,
      month,
      isToggleddata,
      finalStartDate,
      finalEndDate
    ).then(function (result) {
      const response = result?.data;
    //  console.log(response, "rrrr");
      setProductId(response?.data?.listProduct);
    });
  };

  function convertToArrayOfObjects(array) {
    const result = [];
    for (let index = 0; index < array.length; index++) {
      result.push({
        value: {
          code: array[index].Segment.Segment,
          point: "Segment",
          title: array[index].Segment.SegmentTitle,
          id: array[index].Segment.id,
        },
        label: `${array[index].Segment.SegmentTitle} ( Segment - ${array[index].Segment.Segment})`,
      });
      result.push({
        value: {
          code: array[index].Family.Family,
          point: "Family",
          title: array[index].Family.FamilyTitle,
          id: array[index].Family.id,
        },
        label: `${array[index].Family.FamilyTitle} ( Family - ${array[index].Family.Family})`,
      });
      result.push({
        value: {
          code: array[index].Class.Class,
          point: "Class",
          title: array[index].Class.ClassTitle,
          id: array[index].Class.id,
        },
        label: `${array[index].Class.ClassTitle} ( Class - ${array[index].Class.Class})`,
      });
      result.push({
        value: {
          code: array[index].Commodity.Commodity,
          point: "Commodity",
          title: array[index].Commodity.CommodityTitle,
          id: array[index].Commodity.id,
        },
        label: `${array[index].Commodity.CommodityTitle} ( Commodity - ${array[index].Commodity.Commodity})`,
      });
    }
    let jsonObject = result.map(JSON.stringify);
    let uniqueSet = new Set(result.map(JSON.stringify));
    let uniqueArray = Array.from(uniqueSet).map(JSON.parse);
    // console.log(uniqueArray,"res1")
    setSearchOptions(uniqueArray.filter((item) => item.value !== null));
    // return uniqueArray;
  }

  const _SEARCH_UNSPSC = debounce((data) => {
    searchUnspc(data, (res) => {
      convertToArrayOfObjects(res.data);
    });
  }, 500);

  const _SELECT_UNSPSC = (data) => {
  //  console.log(data, "myData");
    setUNSPSCCode(data?.value);
    getUnspcAdd(data, selected, (r) => {
      if (r.success === true) {
        // toast.success(r.message);
        setShowUnspc(false);
        setSegmentCode("");
        afterUpdateUnspschandledata();
      } else {
        toast.error(r.message);
      }
    });
  };

  const initialValues = {
    supplierId: "",
    number: "",
    name: "",
    baseUnit: "",
    baseUnitPrice: "",
    purchasePrice: "",
    currencyType: "",
    VATPercent: "0",
    saleUnitQty: "",
    subUnitQty: "",
    grossWeight: "",
    netWeight: "",
    PackageMaterialForSubUnit: "",
    PackageMaterialForSaleUnit: "",
    salePrice: "",
    discount: "",
    manufactureProductNumber: "",
    manufactureName: "",
    country: "",
    base_unit_of_measure: "",
    sale_unit_of_measure: "",
    sub_unit_of_measure: "",
    web_store_url: "",
    product_web_store_url: "",
    amt_purchase_price: "",
    co2_unt_measure: "",
    co2_qty: "",
    co2_data: "",
    Environmental_Certification: false,
    Environmentally_Friendly_Packaging: false,
  };

  const handleFormSubmit = async (values) => {
    // console.log("values", values);
    const {
      number,
      name,
      manufactureProductNumber,
      manufactureName,
      country,
      sale_unit_of_measure,
      salePrice,
      VATPercent,
      baseUnit,
      base_unit_of_measure,
    } = values;
    // console.log("values", values);
    if (
      number &&
      name &&
      manufactureProductNumber &&
      manufactureName &&
      country &&
      sale_unit_of_measure &&
      salePrice &&
      VATPercent &&
      base_unit_of_measure &&
      baseUnit
    ) {
      const data = {
        ...values,
        supplierId: SupplerId ? SupplerId : values?.supplierId,
        unspscData: UNSPSCCode,
        netWeight: baseUnit,
      };

      const formData = new FormData();

      // Append your data to the FormData object
      formData.append("supplierId", SupplerId ? SupplerId : values?.supplierId);
      formData.append("number", number);
      formData.append("name", name);
      formData.append("baseUnit", baseUnit);
      formData.append("baseUnitPrice", values?.baseUnitPrice);
      formData.append("purchasePrice", values?.purchasePrice);
      formData.append("currencyType", values?.currencyType);
      formData.append("VATPercent", VATPercent);
      formData.append("saleUnitQty", values?.saleUnitQty);
      formData.append("subUnitQty", values?.subUnitQty);
      formData.append("grossWeight", values?.grossWeight);
      formData.append(
        "PackageMaterialForSubUnit",
        values?.PackageMaterialForSubUnit
      );
      formData.append(
        "PackageMaterialForSaleUnit",
        values?.PackageMaterialForSaleUnit
      );
      formData.append("salePrice", salePrice);
      formData.append("discount", values?.discount);
      formData.append("manufactureProductNumber", manufactureProductNumber);
      formData.append("manufactureName", manufactureName);
      formData.append("country", country);
      formData.append("base_unit_of_measure", base_unit_of_measure);
      formData.append("sale_unit_of_measure", sale_unit_of_measure);
      formData.append("sub_unit_of_measure", values?.sub_unit_of_measure);
      formData.append("web_store_url", values?.web_store_url);
      formData.append("product_web_store_url", values?.product_web_store_url);
      formData.append("amt_purchase_price", values?.amt_purchase_price);
      formData.append("co2_unt_measure", values?.co2_unt_measure);
      formData.append("co2_qty", values?.co2_qty);
      formData.append("co2_data", values?.co2_data);
      // formData.append("unspscData", UNSPSCCode);
      formData.append("unspscData", JSON.stringify(UNSPSCCode)); // Serialize the object
      formData.append("netWeight", baseUnit);
      formData.append(
        "Environmental_Certification",
        values?.Environmental_Certification
      );
      formData.append(
        "Environmentally_Friendly_Packaging",
        values?.Environmentally_Friendly_Packaging
      );
      formData.append("env_certificate_file", values?.env_certificate_file);
      try {
        const response = await instance.post(
          `/customer/supplier/add-product-supplier`,
          formData
        );
        toast.success("Successfully added");
        navigate(`/supplierdetailsinfo?id=${SupplerId}&tab=tab4`);
      } catch (err) {
      //  console.log(err);
      }
    } else {
      toast.error("Please fill the required field");
    }
  };

  const countryvalue = () => {
    const filtercountry = countryData?.filter(
      (con) => con.isoCode === supplierDetails.country
    );
    return filtercountry[0]?.name;
  };

  // Search Section
  const searchUnspsc = debounce((input) => {
    setSearch("");
    setPage(1);
    setTotalSearchResult(0);
    setSearchResults([]);

    if (!input) {
      setSearch("");
      return;
    }

    setSearch(input);
  }, 1500);

  const loadMoreResults = () => {
    setPage(page + 1);
  };

  function getSearchResults() {
    setIsSearchLoading(true);

    searchUnspc(search, page, "user", (res) => {
      if (!res.data || res.data.results.length === 0) {
        setSearchResults([]);
        setIsSearchLoading(false);
        return;
      }

      setSearchResults((prevResults) => [...prevResults, ...res.data.results]);
      setTotalSearchResult(res.data.total);
      setSearchResultsEnd(res.data.reachedEnd);
      setIsSearchLoading(false);
    });
  }

  // function getUnspscData(result) {
  //   toast.dismiss();

  //   toast.warning(
  //     <div className="toast-content">
  //       <div className="toast-message">
  //         Are you sure you want to add this UNSPSC?
  //       </div>
  //       <div className="button-container">
  //         <button
  //           className="yes-button"
  //           onClick={() => {
  //             // Proceed with the function if "Yes" is clicked
  //             getSelectedUnspscDetails(result, (res) => {
  //               if (res.success) {
  //                 addUnspscData(res.data.details, selected, (r) => {
  //                   if (r.success === true) {
  //                     toast.success(r.message);
  //                     setPage(1);
  //                     setSearchResults([]);
  //                     setSearch("");
  //                     // handleCloseUnspc();
  //                     // afterUpdateUnspschandledata();
  //                     getSupplierById(SupplerId);
  //                   } else {
  //                     toast.error(r.message);
  //                   }
  //                 });
  //               } else {
  //                 toast.error("Something went wrong");
  //               }
  //             });
  //           }}
  //         >
  //           Yes
  //         </button>
  //         <button
  //           className="no-button ms-2"
  //           onClick={() => {
  //             // Dismiss the toast if "No" is clicked
  //             toast.dismiss();
  //           }}
  //         >
  //           No
  //         </button>
  //       </div>
  //     </div>,
  //     {
  //       autoClose: true, // Keep the toast open until user interacts
  //       closeOnClick: true, // Prevent closing the toast on click
  //     }
  //   );
  // }
  function getUnspscData(result) {
    getSelectedUnspscDetails(result, (res) => {
      if (res.success) {
        // console.log("res.data.details");
        // console.log(res.data.details);

        const unspscData = res?.data?.details;

        setUNSPSCCode(unspscData);
        // console.log(unspscData);
        

        setSelectedSearchResult(res.data.details.title);
        // toast.success("UNSPSC Found.");
        setSearch("");
      } else {
        toast.error("Something went wrong while fetching UNSPSC");
      }
    });
  }

  useEffect(() => {
    getSearchResults();
  }, [search]);

  useEffect(() => {
    if (page > 1) {
      getSearchResults();
    }
  }, [page]);

  function clearSearchResult() {
    setSearch("");
    setSearchResults([]);
    setSelectedSearchResult("");

  }

   // Close the results if clicked outside
   useEffect(() => {
    const handleClickOutside = (event) => {
      if (resultsRef.current && !resultsRef.current.contains(event.target)) {
        setSearch("");
        setSearchResults([]);
        setSelectedSearchResult("");
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener on unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  return (
    <div className="container-fluid">
      <div className="dbMain prdtsbg">
        <Leftpanel breadcm="Product" />
        <div className="dbRight">
          <Header
            link="/products"
            breadcm=""
            title="Add Product"
            description=""
          />
          <div className="commonBase">
            <Formik initialValues={initialValues} onSubmit={handleFormSubmit}>
              {({ values, setFieldValue }) => (
                <Form>
                  <div className="row">
                    {SupplerId && (
                      <>
                        <h5>{t("general_information")}</h5>
                        <Col sm="6" className="mb-3">
                          <FormLabel>{t("supplier_name")}</FormLabel>
                          <Field
                            type="text"
                            name="supplierId"
                            placeholder={t("supenter_plier_name")}
                            className="form-control"
                            value={supplierDetails?.name}
                            readOnly
                          />
                        </Col>
                        <Col sm="6" className="mb-3">
                          <FormLabel>{t("supplier_country")}</FormLabel>
                          <Field
                            type="text"
                            name="suppliercountry"
                            className="form-control"
                            value={countryvalue()}
                            readOnly
                          />
                        </Col>
                      </>
                    )}

                    <Col sm="6" className="mb-3">
                      <FormLabel>
                        {t("product_id")}
                        <span style={{ color: "red" }}> *</span>
                      </FormLabel>
                      <Field
                        type="text"
                        name="number"
                        placeholder={t("enter_product_id")}
                        className="form-control"
                      />
                    </Col>
                    <Col sm="6" className="mb-3">
                      <FormLabel>
                        {t("product_name")}
                        <span style={{ color: "red" }}> *</span>
                      </FormLabel>
                      <Field
                        type="text"
                        name="name"
                        placeholder={t("enter_product_name")}
                        className="form-control"
                      />
                    </Col>

                    <Col sm="6" className="mb-3">
                      <FormLabel>
                        {t("manufacturer_product_number")}
                        <span style={{ color: "red" }}> *</span>
                      </FormLabel>
                      <Field
                        type="text"
                        name="manufactureProductNumber"
                        placeholder={t("enter_manufacturer_product_number")}
                        className="form-control"
                      />
                    </Col>
                    <Col sm="6" className="mb-3">
                      <FormLabel>
                        {t("manufacturer_name")}
                        <span style={{ color: "red" }}> *</span>
                      </FormLabel>
                      <Field
                        type="text"
                        name="manufactureName"
                        placeholder={t("enter_manufacturer_name")}
                        className="form-control"
                      />
                    </Col>
                    <Col sm="6" className="mb-3">
                      <FormLabel>
                        {t("manufacturer_country_of_origin")}
                        <span style={{ color: "red" }}> *</span>
                      </FormLabel>
                      <Field
                        as="select"
                        name="country"
                        className="form-control"
                      >
                        <option value={""}>
                          {t("select_manufacturer_country")}
                        </option>
                        <option selected hidden>
                          {t("select_country")}
                        </option>
                        {countryData.map((con) => (
                          <option
                            key={con.isoCode}
                            value={con.isoCode}
                            selected={
                              con.name === titleCase(adminSupplierData.country)
                            }
                          >
                            {con.name}
                          </option>
                        ))}
                      </Field>
                    </Col>
                    <Col sm="6" className="mb-3">
                      <FormLabel>{t("unspsc")}</FormLabel>
                      <div className="multiSlct mls">
                        {/* {search && <>Total results: {searchResults.length}</>} */}

                        {/* <div className="searchParentDiv"> */}
                        <div>
                          {selectedSearchResult ? (
                            <div className="d-flex form-control align-items-center">
                              <input
                                className="form-control unspscSearchResultBox searchInputBox"
                                type="text"
                                value={selectedSearchResult}
                              />
                              <i className="pointer border-start ps-2 bi bi-x-lg" onClick={() => clearSearchResult()}></i>
                            </div>
                          ) : (
                            <input
                              className="border form-control searchInputBox"
                              type="search"
                              placeholder="Type something to search..."
                              onChange={(e) => searchUnspsc(e.target.value)}
                            />
                          )}
                        </div>
                        {search && (
                          <div 
                          className="searchResults border"
                          ref={resultsRef} // Set the ref to this div
                          >
                            {searchResults && searchResults.length > 0 ? (
                              <>
                                {searchResults.map((result, index) => (
                                  <div
                                    className="form-check d-flex justify-content-between"
                                    key={index}
                                    onClick={() => getUnspscData(result)}
                                  >
                                    <div>
                                      {index +
                                        1 +
                                        ". " +
                                        result.value +
                                        " (" +
                                        result.belongsTo +
                                        " " +
                                        result.key +
                                        ")"}
                                    </div>
                                    <div>
                                      <i
                                        className="fa fa-plus theme-color"
                                        aria-hidden="true"
                                        title="Click to Add"
                                      ></i>
                                    </div>
                                  </div>
                                ))}

                                {/* Load More Button */}
                                {totalSearchResult > searchResults.length && (
                                  <div className="load-more d-flex justify-content-center">
                                    {isSearchLoading ? (
                                      <button disabled>
                                        <i className="fa-solid fa-spinner fa-spin"></i>{" "}
                                      </button>
                                    ) : (
                                      !searchResultsEnd && (
                                        <button
                                          type="button"
                                          onClick={loadMoreResults}
                                        >
                                          Load More
                                        </button>
                                      )
                                    )}
                                  </div>
                                )}
                              </>
                            ) : (
                              <div
                                className="form-check"
                                style={{ textAlign: "center" }}
                              >
                                {isSearchLoading ? (
                                  <i className="fa-solid fa-spinner fa-spin"></i>
                                ) : (
                                  "No Result Found"
                                )}
                              </div>
                            )}
                          </div>
                        )}
                        {/* </div> */}

                        {/* <Select
                          options={searchOptions}
                          placeholder={t("search_unspsc")}
                          noOptionsMessage={() => t("no_unspsc_message")}
                          onChange={_SELECT_UNSPSC}
                          onInputChange={_SEARCH_UNSPSC}
                          components={{
                            DropdownIndicator: () => null,
                            IndicatorSeparator: () => null,
                          }}
                        /> */}
                      </div>
                    </Col>
                    <Col sm="6" className="mb-3">
                      <FormLabel>{t("Bar Code")}</FormLabel>

                      <Field
                        type="number"
                        name="bar_code"
                        placeholder={t("enter_barcode")}
                        className="form-control"
                      />
                    </Col>
                    <Col sm="6" className="mb-3">
                      <FormLabel>{t("product_web_store_url")}</FormLabel>

                      <Field
                        type="text"
                        name="product_web_store_url"
                        placeholder={t("website_url")}
                        className="form-control"
                      />
                    </Col>
                    <h5>{t("price")}</h5>
                    <Col sm="6" className="mb-3">
                      <FormLabel>
                        {t("sale_unit_price")}
                        <span style={{ color: "red" }}> *</span>
                      </FormLabel>
                      <Field
                        type="text"
                        name="salePrice"
                        placeholder={t("enter_sale_unit_price")}
                        className="form-control"
                      />
                    </Col>
                    <Col sm="6" className="mb-3">
                      <FormLabel>{t("discount")}</FormLabel>
                      <Field
                        type="number"
                        name="discount"
                        placeholder={t("enter_discount")}
                        className="form-control"
                      />
                    </Col>
                    <Col sm="6" className="mb-3">
                      <FormLabel>
                        {t("vat_percentage")}
                        <span style={{ color: "red" }}> *</span>
                      </FormLabel>
                      <Field
                        as="select"
                        name="VATPercent"
                        className="form-control"
                      >
                        <option value={""}>{t("select_vat_percentage")}</option>
                        {vatList.map((data, index) => (
                          <option key={index} value={data}>
                            {data}
                          </option>
                        ))}
                      </Field>
                    </Col>
                    <h5>{t("kgco2")}</h5>

                    <Col sm="6" className="mb-3">
                      <FormLabel>{t("kgco2_per_co2_unit")}</FormLabel>
                      <Field
                        type="number"
                        name="kgco2_co2_unit"
                        placeholder={t("enter_kgco2_per_co2_unit")}
                        className="form-control"
                      />
                    </Col>
                    <h5>{t("units_of_measures")}</h5>
                    <Col sm="6" className="mb-3">
                      <FormLabel>
                        {t("sale_unit")}
                        <span style={{ color: "red" }}> *</span>
                      </FormLabel>
                      <Field
                        as="select"
                        name="sale_unit_of_measure"
                        className="form-control"
                      >
                        <option>{t("enter_sale_unit")}</option>
                        {unitData?.map((data, index) => (
                          <option key={index} value={data.common_unit}>
                            {data.common_unit}
                          </option>
                        ))}
                      </Field>
                    </Col>
                    <Col sm="6" className="mb-3">
                      <FormLabel>{t("sale_unit_quantity")}</FormLabel>
                      <Field
                        type="number"
                        name="saleUnitQty"
                        placeholder={"1"}
                        className="form-control"
                        readOnly
                      />
                    </Col>

                    <Col sm="6" className="mb-3">
                      <FormLabel>
                        {t("base_unit")}
                        <span style={{ color: "red" }}> *</span>
                      </FormLabel>
                      <Field
                        as="select"
                        name="base_unit_of_measure"
                        className="form-control"
                      >
                        <option>{t("select_base_unit")}</option>
                        {unitData?.map((data, index) => (
                          <option key={index} value={data.common_unit}>
                            {data.common_unit}
                          </option>
                        ))}
                      </Field>
                    </Col>
                    <Col sm="6" className="mb-3">
                      <FormLabel>
                        {t("base_unit_quantity")}
                        <span style={{ color: "red" }}> *</span>
                      </FormLabel>
                      <Field
                        type="text"
                        name="baseUnit"
                        placeholder={t("enter_base_unit_quantity")}
                        className="form-control"
                      />
                    </Col>

                    <Col sm="6" className="mb-3">
                      <FormLabel>{t("sub_unit")}</FormLabel>
                      <Field
                        as="select"
                        name="sub_unit_of_measure"
                        className="form-control"
                      >
                        <option value={""}>{t("select_sub_unit")}</option>
                        {unitData?.map((data, index) => (
                          <option key={index} value={data.common_unit}>
                            {data.common_unit}
                          </option>
                        ))}
                      </Field>
                    </Col>
                    <Col sm="6" className="mb-3">
                      <FormLabel>{t("sub_unit_quantity")}</FormLabel>
                      <Field
                        type="text"
                        name="subUnitQty"
                        placeholder={t("enter_sub_unit_quantity")}
                        className="form-control"
                      />
                    </Col>
                    <Col sm="6" className="mb-3">
                      <FormLabel>{t("co2e_unit")}</FormLabel>
                      <Field
                        as="select"
                        name="co2_unt_measure"
                        className="form-control"
                      >
                        <option value={""}>{t("select_co2e_unit")}</option>
                        {unitData?.map((data, index) => (
                          <option key={index} value={data.common_unit}>
                            {data.common_unit}
                          </option>
                        ))}
                      </Field>
                    </Col>
                    <Col sm="6" className="mb-3">
                      <FormLabel>{t("co2e_unit_quantity")}</FormLabel>
                      <Field
                        type="number"
                        name="co2_qty"
                        placeholder={t("enter_co2e_unit_quantity")}
                        className="form-control"
                      />
                    </Col>

                    <h5>{t("WeightAndMaterials")}</h5>

                    <Col sm="6" className="mb-3">
                      <FormLabel>{t("GrossWeight")}</FormLabel>
                      <Field
                        type="text"
                        name="grossWeight"
                        placeholder={t("EnterGrossWeight")}
                        className="form-control"
                      />
                    </Col>
                    <Col sm="6" className="mb-3">
                      <FormLabel>{t("DryWeight")}</FormLabel>
                      <Field
                        type="text"
                        name="netWeight"
                        value={values?.baseUnit}
                        readOnly
                        className="form-control"
                      />
                    </Col>
                    <Col sm="6" className="mb-3">
                      <FormLabel>{t("PackageMaterialForSubUnit")}</FormLabel>
                      <Field
                        type="text"
                        name="PackageMaterialForSubUnit"
                        placeholder={t("EnterPackageMaterialForSubUnit")}
                        className="form-control"
                      />
                    </Col>
                    <Col sm="6" className="mb-3">
                      <FormLabel>{t("PackageMaterialForSaleUnit")}</FormLabel>
                      <Field
                        type="text"
                        name="PackageMaterialForSaleUnit"
                        placeholder={t("EnterPackageMaterialForSaleUnit")}
                        className="form-control"
                      />
                    </Col>
                    <Col sm="12" className="mb-3">
                      <FormCheck
                        label="Environmental Certification"
                        name="Environmental_Certification"
                        onChange={(e) =>
                          setFieldValue(
                            "Environmental_Certification",
                            e.target.checked
                          )
                        }
                      />
                    </Col>
                    {values.Environmental_Certification && (
                      <Col sm="6" className="mb-3">
                        <FormControl
                          type="file"
                          onChange={(e) =>
                            setFieldValue(
                              "env_certificate_file",
                              e.target.files[0]
                            )
                          }
                        />
                      </Col>
                    )}
                    <Col sm="12" className="mb-3">
                      <FormCheck
                        label="Environmentally Friendly Packaging"
                        name="Environmentally_Friendly_Packaging"
                        onChange={(e) =>
                          setFieldValue(
                            "Environmentally_Friendly_Packaging",
                            e.target.checked
                          )
                        }
                      />
                    </Col>
                  </div>

                  <button type="submit" className="commonButton">
                    Save
                  </button>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Addproduct;
